module.exports = __webpack_public_path__ + "img/empty_job_alert.88c51eb2.svg";